module.exports = __webpack_public_path__ + "static/alfastuc-sierpleister-17b77a9a902afca6cf935006de4f5b1a.jpg";